import { doc, onSnapshot, getFirestore, updateDoc } from "firebase/firestore";

class EmailConfirmationService {
  constructor() {
    this.db = getFirestore();
    this.unsubscribeFn = null;
  }

/**
 * Подписка на изменение поля `verified` у email.
 * @param {string} email - email пользователя
 * @param {Function} onVerified - колбэк, вызывается при verified === true
 */
subscribe(email, onVerified) {
  if (!email) {
    console.warn("❗️ Email не указан для подписки");
    return;
  }

  const docRef = doc(this.db, "EmailVerification", email);
  console.log("📡 Подписка на документ:", docRef.path);

  this.unsubscribeFn = onSnapshot(docRef, (docSnap) => {
    if (!docSnap.exists()) {
      console.log("📭 Документ ещё не создан или не существует:", email);
      return;
    }

    const data = docSnap.data();
    console.log("📦 Получены данные:", data);

    if (data.verified === true) {
      console.log("✅ Email подтверждён в Firebase!");
      onVerified();
    } else {
      console.log("⏳ Email ещё не подтверждён:", data);
    }
  }, (error) => {
    console.error("🔥 Ошибка при подписке на документ:", error);
  });
}

  unsubscribe() {
    if (this.unsubscribeFn) {
      console.log("📭 Отписка от Firestore listener");
      this.unsubscribeFn(); // снимаем подписку
      this.unsubscribeFn = null;
    }
  }

  /**
   * Отмечает email как подтверждённый в Firestore
   * @param {string} email 
   */
  async markAsVerified(email) {
    if (!email) {
      console.warn("❌ Email не указан для подтверждения");
      return;
    }

    try {
      const docRef = doc(this.db, "EmailVerification", email);
      await updateDoc(docRef, { verified: true });
      console.log("✅ Email отмечен как подтверждённый в Firestore");
    } catch (error) {
      console.error("🔥 Ошибка при обновлении EmailVerification:", error);
    }
  }

}

export default new EmailConfirmationService();